module.exports = __webpack_public_path__ + "img/image23@3x.7096f03c.png";